var AgreementsDialogInternalEvents;
(function(AgreementsDialogInternalEvents) {
    AgreementsDialogInternalEvents["ACCEPT"] = 'agreements dialog: accept';
    AgreementsDialogInternalEvents["DECLINE"] = 'agreements dialog: decline';
})(AgreementsDialogInternalEvents || (AgreementsDialogInternalEvents = {}));
var AgreementsDialogPublicEvents;
(function(AgreementsDialogPublicEvents) {
    AgreementsDialogPublicEvents["ACCEPT"] = 'agreements dialog: accept';
})(AgreementsDialogPublicEvents || (AgreementsDialogPublicEvents = {}));

export { AgreementsDialogInternalEvents, AgreementsDialogPublicEvents };
